export default __webpack_public_path__ + "static/media/step_5.01264a40.svg";